module.exports = __webpack_public_path__ + "files/beep.41cdb2edbb466d38aa5ef2e84b3eee19.wav";